import { useContext } from 'react';
import AppStateContext from './AppStateContext';

export default function useAppState() {
  return useContext(AppStateContext);
}
